import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PageHero, Reveal } from "@/components/bits/Reveal";
import { useSEO } from "@/lib/seo";

const SECTIONS = [
  {
    id: "privacy",
    title: "Privacy Policy",
    body: [
      "Maqline Solutions Pvt Ltd collects personal information that you voluntarily submit through our website forms — such as your name, phone number, email address, qualification, experience and employment preferences — solely to respond to your enquiry, process your application or discuss a partnership.",
      "We do not sell, rent or trade your personal information to third parties. Information shared with client organizations is limited to what is necessary for recruitment, internship or training coordination, and happens only in the context of opportunities you have applied for or consented to.",
      "You may request correction or deletion of your submitted information at any time by writing to info@maqlinesolutions.com.",
    ],
  },
  {
    id: "terms",
    title: "Terms & Conditions",
    body: [
      "The content on this website is provided for general information about Maqline Solutions Pvt Ltd and its workforce solutions, recruitment, internship and training services.",
      "Job listings, program details, stipends and benefits shown on this website are subject to change and to the terms of the respective client organization or program. Submitting an application or enquiry does not guarantee selection, employment, internship confirmation or stipend.",
      "By using this website you agree not to submit false, misleading or fraudulent information through our forms. Maqline reserves the right to decline engagement where submitted information cannot be verified.",
    ],
  },
  {
    id: "disclaimer",
    title: "Disclaimer",
    body: [
      "Maqline Solutions Pvt Ltd does not guarantee employment, placement, internship confirmation, stipend amounts or salary figures. All selections are made by the respective employer or host organization based on their requirements and the candidate's performance.",
      "Statistics shown on this website — such as 600+ candidates deployed across our client network and 500+ students trained — reflect our own engagement records. Company names shown in our client network indicate association and do not imply endorsement by those organizations.",
      "Stipend ranges, where mentioned, are indicative and depend on program, role, organization and applicable terms.",
    ],
  },
];

export default function Legal() {
  useSEO("Privacy Policy, Terms & Disclaimer | Maqline Solutions Pvt Ltd", "Privacy policy, terms of use and disclaimer for the Maqline Solutions website.");
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 200);
    }
  }, [hash]);

  return (
    <main data-testid="legal-page">
      <PageHero overline="Legal" titleLines={["Policies & Disclaimers"]} description="How we handle your information and the terms that govern this website." />
      <section className="bg-white py-16 sm:py-20">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 space-y-16">
          {SECTIONS.map((s) => (
            <div key={s.id} id={s.id} className="scroll-mt-28" data-testid={`legal-${s.id}`}>
              <Reveal>
                <h2 className="font-display text-3xl text-ink mb-6">{s.title}</h2>
                <div className="space-y-4">
                  {s.body.map((p, i) => (
                    <p key={i} className="text-sm sm:text-base text-muted leading-relaxed">{p}</p>
                  ))}
                </div>
              </Reveal>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
